import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Componente genérico para mostrar tarjetas de estado con contador
 * Usado en dashboards para mostrar estadísticas
 */
@Component({
  selector: 'app-status-card',
  templateUrl: './status-card.component.html',
  styleUrls: ['./status-card.component.scss']
})
export class StatusCardComponent {
  /** Título de la tarjeta (clave de traducción) */
  @Input() title: string = '';

  /** Contador a mostrar */
  @Input() count: number = 0;

  /** Color/estado de la tarjeta (usado para estilos CSS) */
  @Input() statusColor: string = '';

  /** Texto del pie de la tarjeta (clave de traducción) */
  @Input() footerText: string = '$general.txtClickToSee';

  /** Icono de FontAwesome a mostrar */
  @Input() icon: string = 'fa-box';

  /** Texto de descripción del contador (clave de traducción) */
  @Input() countLabel: string = '';

  /** Si es clickeable, se puede hacer click en la tarjeta */
  @Input() clickable: boolean = true;

  /** Evento emitido cuando se hace click en la tarjeta */
  @Output() onClick = new EventEmitter<void>();

  /**
   * Maneja el click en la tarjeta
   */
  public handleClick(): void {
    if (this.clickable) {
      this.onClick.emit();
    }
  }
}
